var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUploadDelete = function SvgUploadDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.939 4.061C14.857-.02 8.143-.02 4.06 4.061-.02 8.143-.02 14.857 4.061 18.94c4.082 4.081 10.796 4.081 14.878 0 4.081-4.082 4.081-10.665 0-14.878Z",
    stroke: "#000",
    fillOpacity: 0.6,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.726 15.779-3.292-3.292-3.291 3.292a.636.636 0 0 1-.922 0 .636.636 0 0 1 0-.922l3.292-3.291L7.22 8.274a.636.636 0 0 1 0-.921.636.636 0 0 1 .922 0l3.291 3.291 3.292-3.291a.636.636 0 0 1 .921 0 .636.636 0 0 1 0 .921l-3.291 3.292 3.291 3.291a.636.636 0 0 1 0 .922.636.636 0 0 1-.921 0Z",
    fill: "#000"
  }))));
};
export default SvgUploadDelete;